export const DEFAULT_METADATA = {
  cacheControl: 'public,max-age=86400',
};
